import { ComponentSingleStyleConfig } from "@chakra-ui/react";
import { focusRing, focusRingInvalid } from "../focusStyles";

export const textareaTheme: ComponentSingleStyleConfig = {
  variants: {
    outline: {
      borderColor: "gray.300",
      borderRadius: "md",

      _hover: {
        borderColor: "gray.400",
      },

      _focus: {
        borderColor: "gray.700",
        ...focusRing,
      },

      _invalid: {
        borderColor: "error.500",
        boxShadow: "none",

        _hover: {
          borderColor: "error.500",
        },

        _focus: {
          borderColor: "error.500",
          ...focusRingInvalid,
        },
      },
    },
  },
};
